import request from '@/utils/request'
import { parseStrEmpty } from '@/utils/base';

//从环境变量获取auth服务的路径
const VUE_APP_ROLE_PATH = process.env.VUE_APP_ROLE_PATH

//初始化state
const state = {
}
  
//定义getter
const getters = {

}

//定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    // 查询当前部门的所有用户信息
    async listUserByDeptId({ commit }, { deptId }) {
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/user/list/dept/${deptId}`;
        const result = await request.get(url);
        //获取服务返回数据
        return result
    },
    /**
     * 查询部门下拉树结构
     */
    async deptTreeSelect(){
        const url = `${VUE_APP_ROLE_PATH}/user/deptTree`;
        const result = await request.get(url);
        return result;
    },
    /**
     * 查询用户列表
     * @param query
     */
    async listUser({ commit }, query){
        const url = `${VUE_APP_ROLE_PATH}/user/list`;
        const result = await request.get(url, {params:query});
        return result;
    },
    // 根据参数键名查询参数值
    async getConfigKey({commit},configKey){
        const url = `${VUE_APP_ROLE_PATH}/config/configKey/${configKey}`;
        const result = await request.get(url);
        return result;
    },
    /**
     * 获取用户详情
     * @param userId
     */
    async getUser({commit},userId){
        const url = `${VUE_APP_ROLE_PATH}/user/${parseStrEmpty(userId)}`;
        const result = await request.get(url);
        return result;
    },
    // 查询部门下拉树结构
    async treeselect(){
        const url = `${VUE_APP_ROLE_PATH}/dept/treeselect`;
        const result = await request.get(url);
        return result;
    },
    /**
     * 新增用户
     */
    async addUser({commit}, data){
        const url = `${VUE_APP_ROLE_PATH}/user`;
        const result = await request.post(url,data);
        return result;
    },

    /**
     * 修改用户
     */
    async updateUser({commit}, data){
        const url = `${VUE_APP_ROLE_PATH}/user`;
        const result = await request.put(url,data);
        return result;
    },
    /**
     * 删除用户
     * @param userId 用户ID
     */
    async delUser({commit},userId){
        const url = `${VUE_APP_ROLE_PATH}/user/${userId}`;
        const result = await request.delete(url);
        return result;
    },
    /**
     * 用户状态修改
     * @param userId 用户ID
     * @param status 用户状态
     */
    async changeUserStatus({commit},data){
        const url = `${VUE_APP_ROLE_PATH}/user/changeStatus`;
        const result = await request.put(url,data);
        return result;
    },
    /**
     * 用户密码重置
     * @param userId 用户ID
     * @param password 密码
     */
    async resetUserPwd({commit},data){
        const result = await request({
            url: `${VUE_APP_ROLE_PATH}/user/resetPwd`,
            method: 'put',
            headers: {
                isEncrypt: true,
                repeatSubmit: false
            },
            data: data
        });
        return result;
    },
    /**
     * 保存授权角色
     * @param data 用户ID
     */
    async updateAuthRole({commit}, data){
        const result = await request({
            url: `${VUE_APP_ROLE_PATH}/user/authRole`,
            method: 'put',
            params: data
        });
        return result;
    },
    /**
     * 查询授权角色
     * @param userId 用户ID
     */
    async getAuthRole({commit}, userId){
        const result = await request({
            url: `${VUE_APP_ROLE_PATH}/user/authRole/${userId}`,
            method: 'get'
        });
        return result;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }